import { render, staticRenderFns } from "./ConfirmNeeded.vue?vue&type=template&id=74f1c21b&scoped=true&"
import script from "./ConfirmNeeded.vue?vue&type=script&lang=js&"
export * from "./ConfirmNeeded.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmNeeded.vue?vue&type=style&index=0&id=74f1c21b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f1c21b",
  null
  
)

export default component.exports